import { Button, Flex, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

type DetailsPanelProps = {
  title: string;
  version?: string | null;
  createdDate: string;
  createdBy: string | null;
  archivedDate?: string | null;
  archivedBy?: string | null;
  onViewHistory: () => void;
};

export const DetailsPanel = ({
  title,
  version,
  createdDate,
  createdBy,
  archivedDate,
  archivedBy,
  onViewHistory,
}: DetailsPanelProps) => {
  const showArchived = Boolean(archivedDate || archivedBy);
  const archivedValue =
    archivedDate && archivedBy
      ? `${archivedDate} by ${archivedBy}`
      : (archivedDate ?? archivedBy ?? "");

  return (
    <Flex flexDirection="column" className={styles.hierarchyDetailsPanel}>
      <Text variant="upper-md" marginBottom="md" className={styles.hierarchyDetailsTitle}>
        {title}
      </Text>
      <Flex
        flexDirection="column"
        gap={SPACING.MEDIUM}
        className={styles.hierarchyDetailsContent}
      >
        {version !== undefined && (
          <Flex alignItems="center">
            <Text variant="secondary-md" className={styles.hierarchyDetailsLabel}>
              Version
            </Text>
            <Flex alignItems="center" gap={SPACING.X_SMALL}>
              <Text variant="regular-md">{version ?? "--"}</Text>
              <Button variant="link" onClick={onViewHistory}>
                View version history
              </Button>
            </Flex>
          </Flex>
        )}
        <Flex alignItems="center">
          <Text variant="secondary-md" className={styles.hierarchyDetailsLabel}>
            Created
          </Text>
          <Text variant="regular-md">
            {createdDate}
            {createdBy ? ` by ${createdBy}` : ""}
          </Text>
        </Flex>
        {showArchived && (
          <Flex alignItems="center" data-testid="hierarchy-details-archived">
            <Text variant="secondary-md" className={styles.hierarchyDetailsLabel}>
              Archived
            </Text>
            <Text variant="regular-md">{archivedValue}</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
